<template>
  <div>
    <v-stepper-step :complete="currentStep > 2" step="2">
      <h3>WHAT TYPE OF ITEM ARE YOU SENDING?</h3>  
    </v-stepper-step>
    <v-stepper-content step="2">
      <v-form v-model="categoryFormValid">
        <v-container fluid>
          <div class="input-wrapper">
            <input id="stuff" hidden />
            <label for="stuff" class="fa fa-exclamation input-icon"></label>
          </div>

          <v-radio-group v-model="contentCategory" row mandatory>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-radio label="Gift" value="Gift"></v-radio>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-radio
                label="Commercial Sample"
                value="Commercial Sample"
              ></v-radio>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-radio label="Returned Goods" value="Returned Goods"></v-radio>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-radio label="Sales of Goods" value="Sales of Goods"></v-radio>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-radio label="Documents" value="Document"></v-radio>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2">
              <v-radio label="Other" value="Other"></v-radio>
            </v-col>
          </v-radio-group>
          <v-row v-if="requiresContentCategoryDescription">
            <v-col cols="12" md="12">
              <v-text-field
                class="hasValidationErrorIcon"
                prepend-inner-icon="mdi-information-outline"
                v-model="contentCategoryDescription"
                :rules="categoryDescriptionRules"
                :counter="50"
                label="Description"
                placeholder="Description"
                required
              >
                <template #label>
                  <h3 class="black--text">
                    <span class="red--text"><strong>* </strong></span
                    >DESCRIPTION:
                  </h3>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-btn
        color="primary"
        @click="goNext()"
        :disabled="!categoryFormValid"
        v-if="!sendingDocument || (sendingDocument && requiresItmattForDocuments)"
      >
        Next
      </v-btn>
      <v-btn text @click="currentStep = 1"> Back </v-btn>
      <p v-if="sendingDocument && !requiresItmattForDocuments">
        Go to the nearest post office or sub post office.
      </p>
      <p v-if="sendingDocument && !requiresItmattForDocuments">
        A list of post offices and sub post offices can be found at
        <a href="https://www.maltapost.com/search-letter-box-outlets?l=1&l=1"
          >www.maltapost.com/outlets</a
        >.
      </p>
    </v-stepper-content>
  </div>
</template>

<script>
import validationRules from "../../helpers/ValidationRules";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("declarations/Step02Category");

export default {
  name: "Step02Category",
  data() {
    return {
      ...validationRules,
      categoryFormValid: false,
    };
  },
  computed: {
    ...mapGetters(["sendingDocument", "requiresContentCategoryDescription"]),    
    contentCategory: {
      set(contentCategory) {
        this.$store.dispatch(
          "declarations/Step02Category/setContentCategory",
          contentCategory
        );
      },
      get() {
        return this.$store.state.declarations.Step02Category.contentCategory;
      },
    },
    contentCategoryDescription: {
      set(contentCategoryDescription) {
        this.$store.dispatch(
          "declarations/Step02Category/setContentCategoryDescription",
          contentCategoryDescription
        );
      },
      get() {
        return this.$store.state.declarations.Step02Category
          .contentCategoryDescription;
      },
    },
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("declarations/setCurrentStep", currentStep);
      },
      get() {
        return this.$store.getters["declarations/currentStep"];
      },
    },
    requiresItmattForDocuments: {      
      get() {
        return this.$store.getters["declarations/requiresItmattForDocuments"];
      },
    },
  },
  methods: {
    goNext() {
      if (!this.$store.getters['declarations/hsCodes'].length && 
          (this.sendingDocument && this.requiresItmattForDocuments)) {
        this.$store.dispatch('declarations/getHsCodes');
      }

      this.$store.dispatch("declarations/setCurrentStep", 3);
      this.$emit("showNextStep");
    },
  },
};
</script>